import { useAppSelector } from "redux/store";
import { GuidByUrl } from "./giud-by-url";
import { selectLogin } from "redux/selectors";
import { PasswordCheck } from "./password-check";
import { HomePage } from "pages/home";

export const PrivateRoute = () => {
  const { guid, session, isLogged } = useAppSelector(selectLogin);
  if (isLogged) {
    return <HomePage />;
  }
  return guid && session ? <PasswordCheck guid={guid} /> : <GuidByUrl />;
};
